// Don't allow multiple submissions of the form in quick succession

type SubmitElement = HTMLButtonElement | HTMLInputElement;

const submitElements: NodeListOf<SubmitElement> = document.querySelectorAll(
  ".umbraco-forms-form input[type=submit], .umbraco-forms-form button[type=submit]",
);
const forms: NodeListOf<HTMLFormElement> = document.querySelectorAll(
  ".umbraco-forms-form",
);

const clickHandler = (e: Event) => {
  const input = e.currentTarget as SubmitElement;
  const form = input?.closest("form") as HTMLFormElement;
  form?.addEventListener("submit", disableMultipleSubmitCallback(input, form));
};

const disableMultipleSubmitCallback =
  (submitEl: SubmitElement, form: HTMLFormElement) => () => {
    form?.setAttribute("disabled", "disabled");
    submitEl?.setAttribute("disabled", "disabled");
  };

submitElements?.forEach((el: SubmitElement) => {
  el?.addEventListener("click", clickHandler);
});
